/*
存放所有组件里面公共的函数，方便后期维护
文件包含的功能
drawLine 画线函数
drawLineAndProLine 画两条线
xAxisSub 显示两个x轴的差，需要xAxisSubData传入参数，可以默认不写
chartClick 图谱点击事件

需要注册一下单击事件，可以放在下面这一行代码的下面
-> that.mychart = that.echarts.init(that.$refs.SmyChart, 'halloween')

//扩大点击响应的范围
// 当点击图谱区域时，获得当前x轴坐标，并进行波形频谱图重绘
that.mychart.getZr().off("click");
that.mychart.getZr().on("click", this.chartClick);

 */

import {numberUtilsMixin} from "./numberUtilsMixin";

const commonMixin = {
  mixins: [numberUtilsMixin],
  data() {
    return {
      subTitleData: { // 差值的标题
        index: 1, // 显示两个x轴的差的title索引
        offsetX: 0,
        offsetY: 0,
      },
      proLine: null, // 上一条线下标
      proLineSeriesIndex: null, // 上一条线的seriesIndex
      clickParam: {},
      isMouseInChart: false,
      endClickChartFlag: false
    }
  },
  mounted() {

  },
  methods: {

    /**
     * 显示两个x轴的差
     * 需要修改optin的title，添加第二个标题，通过修改第二个标题实现显示功能
     * @update 更新日期2022-03-18 09:06:05
     * @param time1
     * @param time2
     */
    xAxisSub(a1, a2, seriesIndex1, seriesIndex2) {
      // a1 保存小的坐标 a2保存大的坐标
      if(a1 > a2) {
        let t = a2;
        a2 = a1;
        a1 = t;
        let t2 = seriesIndex1
        seriesIndex1 = seriesIndex2
        seriesIndex2 = t2
      }

      // 计算y轴的差值
      const op = this.mychart.getOption()
      const y1 = op.xAxis[0].data.indexOf(a1)
      const y2 = op.xAxis[0].data.indexOf(a2)
      // 幅值差量
      const subFuzhi = op.series[seriesIndex1].data[y2] - op.series[seriesIndex2].data[y1]

      const titles = op.title
      let xName = op.xAxis[0].name.substring(1, op.xAxis[0].name.length - 1);
      let yName = op.yAxis[0].name.substring(1, op.yAxis[0].name.length - 1)
      let titleIndex = this.subTitleData.index
      titles[titleIndex].text = `[差量${this.roundToDecimalPlaces((a2 - a1),2)}${xName},${this.roundToDecimalPlaces(subFuzhi,2)}${yName}]`
      const option = {
        title: titles
      }
      this.mychart.setOption(option)
    },

    /**
     * 图表鼠标单击事件处理
     * 使用方法，任意位置注册即可
     * this.mychart.getZr().off("click");
     * this.mychart.getZr().on("click", this.chartClick);
     * @param params
     */
    chartClick(params) {

      // 如果点击了可拖拽的标注，不执行下面的代码
      if (this.clickgraphic) {
        this.clickgraphic = false;
        return ;
      }

      console.log(params);
      const chart = this.mychart
      //获取当前图表的option
      var op = chart.getOption();

      const pointInPixel = [params.offsetX, params.offsetY];
      // >> 处置无线机泵获取最近高亮点
      let highLightIndex = -1;
      if(this.isWirelessPumpTrendGraph !== 'undefined' && this.isWirelessPumpTrendGraph && this.highLightPoints)  {
        let timeX = this.$store.state.tooltipTime;

        var min = Number.MAX_VALUE;
        // console.log("high", this.highLightPoints);
        for(let i = 0; i < this.highLightPoints[0].length; ++i) {
          let pointX = new Date(this.highLightPoints[0][i].xAxis).getTime();
          if(Math.abs(pointX-timeX) < min) {
            min = Math.abs(pointX-timeX);
            highLightIndex = i;
          }
        }
        if(highLightIndex != -1) {
          this.$store.state.tooltipTime = new Date(this.highLightPoints[0][highLightIndex].xAxis).getTime();
        }
      }
      // << 处置无线机泵获取最近高亮点

      if (this.mychart.containPixel("grid", pointInPixel)) {
        let pointInGrid = this.mychart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];
        let modelFlag = op.xAxis[0].type != 'category'

        // console.log(this.$store.state.tooltipTime, this.$store.state.modelFlag, this.typename);
        if (modelFlag && this.typename == '趋势图') {
          // console.log(this.$store.state.tooltipTime, op.xAxis[0].data);
          for (let item in op.xAxis[0].data) {
            if (new Date(op.xAxis[0].data[item]).getTime() == this.$store.state.tooltipTime) {
              xIndex = Number(item);
              // console.log('匹配成功',item, new Date(op.xAxis[0].data[item]).getTime(), op.xAxis[0].data[item]);
              break;
            }
          }
        }

        if (this.graphType == '趋势图' || this.graphType === '倒谱图' || this.graphType === '频谱图' || this.graphType === '波形图') {
          xIndex = Number(this.tooltipIndex);
        }

        //Y轴序号
        var yIndex = pointInGrid[1];
        // if(highLightIndex != -1) yIndex = this.highLightPoints[highLightIndex][1];
        console.log("happen->xIndex yIndex", xIndex, yIndex)
        // >> 处理轴心位置标点
        const isMarkMode = this.markPoint && this.markPoint.isMark;

        let closePointIndex = -1;
        if (this.axisPositionFlag !== 'undefined' && this.axisPositionFlag) {
          let closestLine = this.getAxisPosition(params, xIndex, yIndex);
          xIndex = this.roundToDecimalPlaces(closestLine[0],3);
          yIndex = this.roundToDecimalPlaces(closestLine[1],3);
          closePointIndex = closestLine[2];

          // 只有在非标注模式下才触发游标事件
          if (!isMarkMode) {
            var param = {};
            param.name = this.posListTime[closePointIndex];
            param.xIndex = xIndex
            if(this.status == undefined || this.status != 'real') {
              this.$emit("chartinfo", param);
            }
            const isPrimaryCursor = this.PrimarySecondary.isMark;
            this.handleAxisPosition(params, xIndex, yIndex, isPrimaryCursor);
          }
          return
        }
        // << 处理轴心位置标点

        // 获取离鼠标最近的 series 的线的index，以便提供给其它组件
        var min = Number.MAX_VALUE;
        var seriesNameIndex = 0;
        if(this.tooltipSeriesIndex === undefined || this.tooltipSeriesIndex === ''){
          for (var i = 0; i < op.series.length; i++) {
            // console.log(op.series[i].data[xIndex]);
            try {
              if (op.series[i].data && (modelFlag ? op.series[i].data[xIndex][1] : op.series[i].data[xIndex]) != null && Math.abs((modelFlag ? op.series[i].data[xIndex][1] : op.series[i].data[xIndex]) - yIndex) < min) {
                min = Math.abs((modelFlag ? op.series[i].data[xIndex][1] : op.series[i].data[xIndex]) - yIndex);
                seriesNameIndex = i;
              }
            } catch (e) {
              console.log(e);
            }
          }
        }else{
          seriesNameIndex = this.tooltipSeriesIndex
        }

        console.log("happen->seriesNameIndex", seriesNameIndex)

        if (this.markPoint.isMark) {
          // 处理图表标注功能
          // console.log(xIndex, yIndex, op.xAxis[0].data[xIndex], this.$store.state.tooltipTime);
          console.log("标注模式激活 - 参数:", {xIndex, seriesNameIndex, yIndex, closePointIndex});
          console.log("markPoint 对象:", this.markPoint);
          console.log("markPointList 数组:", this.markPointList);
          this.markPointFun(xIndex, seriesNameIndex, yIndex, closePointIndex);
          return;
        }
        if(this.markLine != undefined && this.markLine.isResonance) {
          // 处理 谐频
          this.harmonicFrequency(xIndex)
          return
        }

        this.hideAllInput()

        //获得图表中我们想要的数据封装为param {name: '2022-03-05 07:51:38.785', seriesName: '2级A壳体振动V'}
        var param = {};
        if(op.xAxis[0].type == 'category') {
          param.name = op.xAxis[0].data[xIndex];
        } else {
          param.name = op.series[seriesNameIndex].data[xIndex][0]
        }
        param.xIndex = xIndex
        param.seriesNameIndex = seriesNameIndex
        param.seriesName = op.series[seriesNameIndex].name;
        param.seriesId = op.series[seriesNameIndex].id;//seriesId的值用于往复-振动监测，点击趋势图后显示波形图，请求传参数
        param.seriesY = op.series[seriesNameIndex].data[xIndex]
        param.yIndex = yIndex
        param.isPrimaryCursor = this.PrimarySecondary.isMark !== undefined ? this.PrimarySecondary.isMark : true;
        this.clickParam = param
        console.log("happen->param", param, op.series[seriesNameIndex].data[xIndex])

        // console.log("happen->seriesNameIndex", seriesNameIndex)
        this.endClickChartFlag = true
        if(this.graphType === '倒谱图' || this.graphType === '频谱图' || this.graphType === '波形图'){
          this.drawLineAndProLine(param.name, seriesNameIndex, param, null,xIndex, yIndex)
          this.$emit("chartinfo", param);
          return;
        }


        if(this.status == undefined || this.status != 'real') {
          this.drawLineAndProLine(param.name, seriesNameIndex, param, null,xIndex, yIndex)
          // 告诉父组件刷新其它页面，父组件如果不执行这个函数，相当于没有影响
          this.$emit("chartinfo", param);

        }

      }
    },
    /**
     * 图谱绘图完毕以后执行
     */
    setChartAfter() {
      // console.log("setChartAfter后执行")

      // 初始化最大值最小值框
      if(this.firstEnter != undefined && this.firstEnter) {
        this.firstEnter = false
        this.initMaxInput()
      }

      // 进行标注处理
      if(this.markPoint != undefined && this.markPoint.isMark) {
        console.log("初始化标注状态:", {
          markPoint: this.markPoint,
          markPointList: this.markPointList
        });
        this.markPoint.isMark = false
        this.markPointList = []
        let feature = this.mychart.getOption().toolbox[0].feature;
        if(feature.myMark) feature.myMark.title = this.markPoint.isMark ? this.translateText("textMap.", "取消标注") : this.translateText("textMap.", "标注")
        this.mychart.setOption({
          toolbox: [{
            feature
          }]
        });
      }

      // 进行标点处理
      if(this.myMarkPoint != undefined && this.myMarkPoint.state) {
        console.log("进行标点处理")
        this.myMarkPointFun()

      }
      // 自动寻峰
      if(this.peakSearch != undefined && this.peakSearch.state) {
        this.peakSearchFun()
      }
      //边频
      if (this.sidebandFamily != undefined && this.sidebandFamily.state) {
        this.sidebandFamily.state = false
        let option = {
          toolbox: {
            feature: {
              mySidebandFamily: {
                iconStyle: {
                  borderColor: null
                }
              }
            }
          }
        }
        this.mychart.setOption(option)
      }
      // 清空所有的proLine
      this.proLine = null

      // 在细化，更改时间范围也就是刷新数据的时候，进行最大值最小值框的保留更改
      // this.refreshMinMax()
      if(this.PrimaryLine || this.PrimaryLineParam){
        this.PrimaryLine = null
        this.PrimaryLineParam = null
      }
      if(this.SecondaryLine || this.SecondaryLineParam){
        this.SecondaryLine = null
        this.SecondaryLineParam = null
      }
      if(this.PrimaryMarkPointData != null){
        this.PrimaryMarkPointData = null
      }
      if(this.SecondaryMarkPointData != null){
        this.SecondaryMarkPointData = null
      }
      if(this.dataZoomBegin || this.dataZoomEnd){
        this.dataZoomBegin.length = 0
        this.dataZoomEnd.length = 0
      }
      if(this.xDataZoomBegin || this.xDataZoomEnd ||this.yDataZoomBegin || this.xDataZoomEnd){
        this.xDataZoomBegin.length = 0
        this.xDataZoomEnd.length = 0
        this.yDataZoomBegin.length = 0
        this.xDataZoomEnd.length = 0
      }
      if(this.envelopeType != undefined && this.envelopeType == 0){
        this.highPassOnclick()
      }else if(this.envelopeType != undefined && this.envelopeType == 1) {
        this.bandPassOnclick()
      }

      this.createDropdownMenu();

    },

    /**
     * 获取轴心位置最近点位置
     * 返回值包括x, y, 和对应最近点的下标
     * @param {*} params
     */
    getAxisPosition(params, xIndex, yIndex) {
      const chart = this.mychart
      //获取当前图表的option
      var op = chart.getOption();
      console.log("happen->轴心位置标点op", op);
      console.log("happen->轴心位置标点params", params);

      let series = op.series[0].data;
      // 找到距离xIndex, yIndex距离最近的线
      let closestLine = null;
      let closestDistance = Infinity;
      series.forEach((seriesItem, index) => {
        const distance = Math.abs(xIndex - seriesItem[0])*Math.abs(xIndex - seriesItem[0]) + Math.abs(yIndex - seriesItem[1])*Math.abs(yIndex - seriesItem[1]);
        if (distance < closestDistance) {
          closestLine = [...seriesItem,  index];
          closestDistance = distance;
        }
      });
      console.log("happen->轴心位置标点closestLine", closestLine);
      return closestLine;
    },

    /**
     * 图表鼠标单击事件处理
     * 处理轴心位置标点
     * 需要画出一个十字线
     */
    handleAxisPosition(params, xIndex, yIndex, isPrimaryCursor = null) {
      const chart = this.mychart
      var op = chart.getOption();

      let isPrimaryCursorValue = this.PrimarySecondary.isMark;
      if (typeof isPrimaryCursor === 'boolean') {
        isPrimaryCursorValue = isPrimaryCursor;
      } else if (params && typeof params === 'object' && params.hasOwnProperty('isPrimaryCursor')) {
        isPrimaryCursorValue = params.isPrimaryCursor;
      }

      let xValue, yValue, pointTime, pointIndex;

      if (params && params.name) {
        let targetIndex = this.posListTime.findIndex(time => time === params.name);

        if (targetIndex === -1) {
          const targetTime = new Date(params.name).getTime();
          let minDiff = Infinity;
          this.posListTime.forEach((time, index) => {
            const timeDiff = Math.abs(new Date(time).getTime() - targetTime);
            if (timeDiff < minDiff) {
              minDiff = timeDiff;
              targetIndex = index;
            }
          });
        }
        if (targetIndex !== -1) {
          // 使用时间匹配的结果
          xValue = this.dataList[targetIndex][0];
          yValue = this.dataList[targetIndex][1];
          pointTime = this.posListTime[targetIndex];
        } else {
          return;
        }
      } else {
        // 使用欧几里得距离计算查找最近点
        let closestLine = this.getAxisPosition(params, xIndex, yIndex);
        if (closestLine) {
          xValue = closestLine[0];
          yValue = closestLine[1];
          pointIndex = closestLine[2];
          pointTime = this.posListTime[pointIndex] || '';
        } else {
          return;
        }
      }
      let series = op.series[0];
      let lineColor = isPrimaryCursorValue
        ? this.$store.state.primarySecondaryColor[0]
        : this.$store.state.primarySecondaryColor[1];

      let markLineDataX = {
        xAxis: '' + this.roundToDecimalPlaces(xValue, 3),
        lineStyle: {
          color: lineColor,
          width: 1,
          type: 'dashed'
        },
        id: isPrimaryCursor ? 'Main-Cursor-Line-X' : 'Auxiliary-Cursor-Line-X',
        label: {
          show: false
        }
      };

      let markLineDataY = {
        yAxis: '' + this.roundToDecimalPlaces(yValue, 3),
        lineStyle: {
          color: lineColor,
          width: 1,
          type: 'dashed'
        },
        id: isPrimaryCursor ? 'Main-Cursor-Line-Y' : 'Auxiliary-Cursor-Line-Y',
        label: {
          show: false
        }
      };

      if (isPrimaryCursorValue) {
        this.PrimaryLine = {x: xValue, y: yValue, time: pointTime, pointIndex: pointIndex};
        this.PrimaryLineParam = {xIndex, yIndex};
      } else {
        this.SecondaryLine = {x: xValue, y: yValue, time: pointTime, pointIndex: pointIndex};
        this.SecondaryLineParam = {xIndex, yIndex};
      }

      let existingMarkLines = series.markLine && series.markLine.data ? series.markLine.data.slice() : [];

      existingMarkLines = existingMarkLines.filter(item => {
        if (isPrimaryCursor) {
          const shouldKeep = !(item.id === 'Main-Cursor-Line-X' || item.id === 'Main-Cursor-Line-Y');
          return shouldKeep;
        } else {
          const shouldKeep = !(item.id === 'Auxiliary-Cursor-Line-X' || item.id === 'Auxiliary-Cursor-Line-Y');
          return shouldKeep;
        }
      });

      existingMarkLines.push(markLineDataX, markLineDataY);

      let markPointData = series.markPoint && series.markPoint.data ? series.markPoint.data.slice() : [];

      markPointData = markPointData.filter(item => {
        if (isPrimaryCursor) {
          const shouldKeep = item.name !== '主游标点';
          return shouldKeep;
        } else {
          const shouldKeep = item.name !== '辅游标点';
          return shouldKeep;
        }
      });

      markPointData.push({
        name: isPrimaryCursor ? '主游标点' : '辅游标点',
        coord: [xValue, yValue],
        symbol: 'circle',
        symbolSize: 5,
        itemStyle: {
          color: lineColor,
        }
      });
      // 更新标题显示游标信息
      let titles = op.title ? op.title.slice() : [];
      if (titles.length < 2) {
        while (titles.length < 3) {
          titles.push({text: ''});
        }
      }

      if (isPrimaryCursor) {
        let mainCursorIndex = titles.findIndex(title => title && title.id === 'Main-Cursor-Info');
        const mainCursorTitle = {
          id: 'Main-Cursor-Info',
          top: '45px',
          left: '10%',
          textStyle: {
            fontSize: 10,
            color: this.$store.state.primarySecondaryColor[0],
          },
          text: `[ ${pointTime} X:${this.roundToDecimalPlaces(xValue, 3)}, Y:${this.roundToDecimalPlaces(yValue, 3)}]`
        };

        if (mainCursorIndex !== -1) {
          titles[mainCursorIndex] = mainCursorTitle;
        } else {
          while (titles.length <= 1) {
            titles.push({text: ''});
          }
          titles[1] = mainCursorTitle;
        }
      } else {
        let auxCursorIndex = titles.findIndex(title => title && title.id === 'Auxiliary-Cursor-Info');
        const auxCursorTitle = {
          id: 'Auxiliary-Cursor-Info',
          top: '30px',
          left: '10%',
          textStyle: {
            fontSize: 10,
            color: this.$store.state.primarySecondaryColor[1],
          },
          text: `[ ${pointTime} X:${this.roundToDecimalPlaces(xValue, 3)}, Y:${this.roundToDecimalPlaces(yValue, 3)}]`
        };

        if (auxCursorIndex !== -1) {
          titles[auxCursorIndex] = auxCursorTitle;
        } else {
          while (titles.length <= 2) {
            titles.push({text: ''});
          }
          titles[2] = auxCursorTitle;
        }
      }

      if (this.PrimaryLine && this.SecondaryLine) {
        let xDiff = Math.abs(this.PrimaryLine.x - this.SecondaryLine.x);
        let yDiff = Math.abs(this.PrimaryLine.y - this.SecondaryLine.y);

        let diffTitleIndex = titles.findIndex(title => title && title.id === 'Cursor-Diff-Info');

        const diffTitle = {
          id: 'Cursor-Diff-Info',
          top: '45px',
          left: '60%',
          textStyle: {
            fontSize: 10,
          },
          text: `[${
            this.translateText('textMap.', '差量')
          }: ΔX:${this.roundToDecimalPlaces(xDiff, 3)}, ΔY:${this.roundToDecimalPlaces(yDiff, 3)}]`
        };

        if (diffTitleIndex !== -1) {
          titles[diffTitleIndex] = diffTitle;
        } else {
          titles.push(diffTitle);
        }
      }

      // 应用更新后的配置
      let option = {
        title: titles,
        series: [{
          markLine: {
            data: existingMarkLines
          },
          markPoint: {
            data: markPointData
          }
        }]
      };

      chart.setOption(option);

      // const cursorChangeEvent = {
      //   isPrimaryCursor,
      //   x: xValue,
      //   y: yValue,
      //   time: pointTime
      // };
      // this.$emit("cursorChanged", cursorChangeEvent);
    },



    chartMousemoveEvent(event){
      this.isMouseInChart = true
      // 获取鼠标位置的像素坐标
      const mouseX = event.offsetX;
      const mouseY = event.offsetY;
      const option = this.mychart.getOption()

      // 初始化最小距离和最近点
      let minDistance = Infinity;
      let closestPoint = null;
      if(this.mychart.containPixel("grid", [mouseX, mouseY])){
        // 先去掉循环逻辑直接处理第一条线，后续需求变化在修改回来

        let seriesData = option.series[0].data || [];
        // 遍历所有数据点，计算距离
        seriesData.forEach(point => {
          // 将数据点转换为像素坐标
          const pointPixel = this.mychart.convertToPixel('grid', point);

          // 计算欧几里得距离
          const dx = pointPixel[0] - mouseX;
          const dy = pointPixel[1] - mouseY;
          const distance = Math.sqrt(dx * dx + dy * dy);

          // 更新最近点
          if (distance < minDistance) {
            minDistance = distance;
            closestPoint = point;
            this.tooltipSeriesIndex = 0; // 固定为第一条线的索引
          }
        });
        // for(let i in  option.series){
        //   // 获取系列数据
        //   let seriesData = option.series[i].data || [];
        //   // 遍历所有数据点，计算距离
        //   seriesData.forEach(point => {
        //     // 将数据点转换为像素坐标
        //     const pointPixel = this.mychart.convertToPixel('grid', point);
        //
        //     // 计算欧几里得距离
        //     const dx = pointPixel[0] - mouseX;
        //     const dy = pointPixel[1] - mouseY;
        //     const distance = Math.sqrt(dx * dx + dy * dy);
        //
        //     // 更新最近点
        //     if (distance < minDistance) {
        //       minDistance = distance;
        //       closestPoint = point;
        //       this.tooltipSeriesIndex = i
        //     }
        //   });
        // }
        this.xTooltipData = closestPoint[0]
        this.tooltipIndex = option.series[this.tooltipSeriesIndex].data.indexOf(closestPoint) // 找到最近点的索引
      }
    },

    mouseMoveEvent(event){
      this.isMouseInChart = true
    },

    globalOutEvent(event){
      this.isMouseInChart = false
    },
  },


}

/**
 * 图表的公共toolbox
 */
export default commonMixin



// WEBPACK FOOTER //
// ./src/mixins/commonMixin.js